import React, {useContext} from "react";
import "./AiLoadingElement.scss"
import {I18nReactContext} from "../../../contexts/I18nContext";
import {get} from "lodash";
export const AiLoadingElement = ({ loadingTexts}) => {
    const [text, setText] = React.useState([get(loadingTexts, '[0]', '')])
    const {i18n} = useContext(I18nReactContext)

    //switch text every 4 seconds
    React.useEffect(() => {
        if(loadingTexts.length === 0) {
            return
        }
        let i = 0
        const interval = setInterval(() => {
            setText(loadingTexts[(i+1)%loadingTexts.length])
            i++
            if (i === loadingTexts.length) {
                i = 0
            }
        }, 9000)
        return () => clearInterval(interval)
    }, [loadingTexts])
    return <div className="AiLoadingElement">
        <div className="loadingTextAI">
            {text}
        </div>
        <div className="line-loader">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
        </div>
    </div>
}